import type { PurchasablePlanView } from "@keydials/api-client";

/**
 * Which rung the trial-ended screen pre-selects (KEY-634).
 *
 * The one the organisation was on, when the shop still sells it — that is the plan they chose, and the
 * button says "pick up where I left off". Otherwise the first on the shelf, which is all the screen could
 * do before it knew which rung was theirs. Null when there is nothing to choose.
 */
export function pickReturnPlan(
  plans: readonly PurchasablePlanView[],
  currentPlanId: string | null,
  /**
   * A relative whose place on somebody's family pack ended (KEY-651). Their "current" rung is the buyer's family
   * pack, which they never chose; carrying on alone means a plan for one, so that is what is pre-selected.
   */
  sponsored = false,
): string | null {
  if (sponsored) {
    const single = plans.find((p) => !p.familySeats);
    if (single) return single.id;
  }
  if (currentPlanId && plans.some((p) => p.id === currentPlanId)) return currentPlanId;
  return plans[0]?.id ?? null;
}
